import { executeRequest, Request } from '@jfs/network'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (data: any) => {
  const respData = data
  return respData
}

const updateDeviceConfigReq = (tokens: any, req: any) => {
  const request: Request<{}> = {
    config: sitConfig(tokens),
    apiPath: `${APIEndPoints.changeDeviceConfiguration}`,
    method: 'POST',
    cache: false,
    body: req,
  }
  return executeRequest(request).then((res) => {
    if (res?.status === 'Failed') {
      if (res.data) {
        throw res.data
      } else {
        throw res
      }
    } else {
      return responseParser(res.data)
    }
  })
}

export { updateDeviceConfigReq }
